import { render, staticRenderFns } from "./QuarterlyHeader.vue?vue&type=template&id=6a5ef9da&scoped=true"
import script from "./QuarterlyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./QuarterlyHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuarterlyHeader.vue?vue&type=style&index=0&id=6a5ef9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ef9da",
  null
  
)

export default component.exports